export default "__VITE_ASSET__295cf768__"